import { bindTooltip } from './modules/bind';
import { createTooltip } from './modules/create';

const selectors = {
	tooltipAnchor: '[data-tooltip-text]',
};

// HTML API
document.querySelectorAll(selectors.tooltipAnchor).forEach((anchor) => {
	const tooltipText = anchor.getAttribute('data-tooltip-text');
	const tooltipType = anchor.getAttribute('data-tooltip-type') || 'info';

	if (!tooltipText) {
		return;
	}

	const tooltip = createTooltip(tooltipText, tooltipType);
	bindTooltip(anchor, tooltip);
});

// Global API
window.createTooltip = createTooltip;
window.bindTooltip = bindTooltip;
